import LayoutMain from './../../../../layouts/LayoutMain.vue';
import ProgressHUD from './../../../ProgressHUD/index.vue'
import GoogleMap from './../../../GoogleMap/VueGoogleMap.vue'
import VueGoogleAutocomplete from './../../../GoogleMap/VueGoogleAutocomplete.vue'
import VueCropper from 'vue-cropper'
import { Api, Toast, Helper } from './../../../../services'

export default {
  name: 'ProjectExistingAdd',
  props: [],
  components: {
    LayoutMain,
    ProgressHUD,
    VueCropper,
    GoogleMap,
    VueGoogleAutocomplete
  },
  data() {
    return {
      project: {
        name: '',
        greenTokenWallet: '',
        type: '',
        typeInverter: '',
        streetAddress: '',
        streetAddress2: '',
        city: '',
        stateProvince: '',
        zipCode: '',
        country: '',
        dateInstallation: '',
        nameplateCapacity: '',
        documentations: [],
        CODCertificate: [],
        ownership: [],
        affilietCode: '',
        latitude: null,
        longitude: null,
        images: null,
        capacitySize: '',
        day: "",
        month: "",
        year: "",
        draft: false,
        public: true,
        social: false,
        socialManner: '',
        funding: false,
        fundingAmount: 0,
        newPrj: false,
        presentation: [],
        fundingAmountCurrency: '',
        ppaPrice: null,
        ppaDuration: null
      },
      user: {
        fullName: "",
        email: "",
        address: "",
        address2: "",
        city: "",
        country: "",
        location: "",
        state: "",
        zipcode: "",
        phone: '',   
        company: '',
        jobTitle: '',     
        typeOfProfile: "",
      },
      validationMessage: '',
      types: {
        0: 'Solar Photovoltaic (PV)',
        1: 'Concentrated Solar Power (CSP)',
        2: 'Solar water heating (SWH)',
        3: 'Solar Pump',
        4: 'New Solar Technology',
        5: 'Wind',
        6: 'Home Wind System',
        7: 'Biogas',
        8: 'Wood Gasification',
        9: 'Gasification of Organics',
        10: 'Waste Gasification',
        11: 'Hydroelectric', 
        12: 'Carbon Credits',       
      },
      //12: 'Undumotor',
      typesinverter: {
        0: 'SolarEdge',
        1: 'SMA',
        2: 'Enphase Energy',
      },
      currencies: {
        0: 'USD',
        1: 'Euro',
      },
      otherinverter: "",
      option: {
        img: null,
        size: 1,
        outputType: 'png',
        res: '',
        w: 1200,
        h: 400,
      },
      capacitySize: 0,
      day: "",
      month: "",
      year: "",
      countries: "",
      affilietCode: "",
      draft: false,
      editMode: true,
      addressSearch: '',
      sign: "",
      sign2: "",
      isEdit: false,
      isSolar: false,
      isWind: false,
      isCCType: false,
      images: [],
      profiles: {"0": "affiliate", "1": "investor", "2": "producer"},
      isOtherType: false,
      isNewPrj: false,
      latitude: '',
      longitude: '', 
      isoffGrid: false,    
      isUserAutofill: true, 
      documentations: '',
      certificate: '',
      ownership: '',
      isdoc: false,
      arrUser: {},
      isAutoAddr: true,
      messageEdit: '',
    }
  },
  computed: {
    isLocation() {
      // check if walletAddress is empty
      if (this.user.address === '' && this.user.country) return true // userAddressLocation is required
      return false
    },
    isAddress() {      
      if (this.user.location && this.user.location.latitude === '' && this.user.location.longitude === '') return true // userAddress is required
      return false
    },   
    isDocs() { 
      // setTimeout( function(){    
          // if ($("#exampleFormControlFile3").val() != '') return false // is required
          // else if ($("#exampleFormControlFile12").val() != '' && $("#exampleFormControlFile2").val() != '') return false // is required
      //     console.log("*******************************************************")
      //     console.log($("#exampleFormControlFile12").val(), $("#exampleFormControlFile2").val(), $("#exampleFormControlFile3").val())

      //     if ($("#exampleFormControlFile12").val() == '' && $("#exampleFormControlFile2").val() == '' && $("#exampleFormControlFile3").val()=='')  true
      //     if ($("#exampleFormControlFile12").val() != '' && $("#exampleFormControlFile2").val() == '' && $("#exampleFormControlFile3").val()=='')  true
      //     if ($("#exampleFormControlFile12").val() == '' && $("#exampleFormControlFile2").val() != '' && $("#exampleFormControlFile3").val()=='')  true  
          

      //     // if ((this.$refs.documentations == '' && this.$refs.certificate == '') || ( this.$refs.ownership == '' && this.$refs.certificate == '')) return true // is required
      //     return false
      // }, 1000)
    },    
    isAddressPrj() {   
      if (this.project.latitude == null && this.project.longitude == null && this.project.streetAddress == '' && this.project.country == '') return true // project Address is required if lat/long is empty
      else return false  
      // if (this.project.streetAddress === '' && this.project.country === '') return true 
      
    },
    years () {
      const year = new Date().getFullYear()
      return Array.from({length: year - 1979}, (value, index) => 1980 + index)
    }
  },
  methods: {
    /**
    * When the location found
    * @param {Object} addressData Data of the found location
    * @param {Object} placeResultData PlaceResult object
    * @param {String} id Input container ID
    */
    getAddressData(addressData, placeResultData, id) {
      let address = placeResultData.address_components

      let streetNumber  = ((address.find(item => item.types.includes("street_number")) || {}).long_name || "")
      if (streetNumber) {
        streetNumber = ", " + streetNumber
      }

      this.project.streetAddress = "" // this for fix binding. If you enter the same address twice, another full address may be displayed and not specified.
      this.project.streetAddress = ((address.find(item => item.types.includes("route")) || {}).long_name || "") + streetNumber
      this.project.city = ((address.find(item => item.types.includes("locality")) || {}).long_name || "")
      this.project.zipCode = ((address.find(item => item.types.includes("postal_code")) || {}).long_name || "")
      this.project.stateProvince = ((address.find(item => item.types.includes("administrative_area_level_1")) || {}).long_name || "")
      this.project.country = ((address.find(item => item.types.includes("country")) || {}).long_name || "")

      this.$refs.googleMapProjectGeolocation.setPosition(addressData.latitude, addressData.longitude)
      this.$refs.googleMapProjectGeolocation.streetAddress = placeResultData.formatted_address
    },
    /**
    * When the location found
    * @param {Object} addressData Data of the found location
    * @param {Object} placeResultData PlaceResult object
    * @param {String} id Input container ID
    */
    getProjectLocalAddressData(addressData, placeResultData, id) {
      let address = placeResultData.address_components

      let streetNumber  = ((address.find(item => item.types.includes("street_number")) || {}).long_name || "")
      if (streetNumber) {
        streetNumber = ", " + streetNumber
      }

      this.user.address = "" // this for fix binding. If you enter the same address twice, another full address may be displayed and not specified.
      this.user.address = ((address.find(item => item.types.includes("route")) || {}).long_name || "") + streetNumber
      this.user.city = ((address.find(item => item.types.includes("locality")) || {}).long_name || "")
      this.user.zipcode = ((address.find(item => item.types.includes("postal_code")) || {}).long_name || "")
      this.user.state = ((address.find(item => item.types.includes("administrative_area_level_1")) || {}).long_name || "")
      this.user.country = ((address.find(item => item.types.includes("country")) || {}).long_name || "")

      this.$refs.googleMapProjectLocalPointGeolocation.setPosition(addressData.latitude, addressData.longitude)
      this.$refs.googleMapProjectLocalPointGeolocation.streetAddress = placeResultData.formatted_address
    },
    // async getStreetAddressFrom() {      
    //    try {
    //     var lat = this.latitude, long = this.longitude
    //     console.log("getStreetAddressFrom", lat, long)
    //       var 
    //          data = await axios.get(
    //          "https://maps.googleapis.com/maps/api/geocode/json?latlng=" +
    //          lat +
    //          "," +
    //          long +
    //          "&key=AIzaSyB9-Cxfd2WERyyZ7LS79_3mU7MrudkKXIQ"
    //       );
    //       if (data.error_message) {
    //          console.log(data.data.error_message)
    //       } else {
             
    //          console.log(data.data.results[0])
    //          var address = data.data.results[0].address_components

    //          let streetNumber  = ((address.find(item => item.types.includes("street_number")) || {}).long_name || "")
    //          if (streetNumber) {
    //            streetNumber = ", " + streetNumber
    //          }

    //         this.project.streetAddress = "" // this for fix binding. If you enter the same address twice, another full address may be displayed and not specified.
    //         this.project.streetAddress = ((address.find(item => item.types.includes("route")) || {}).long_name || "") + streetNumber
    //         this.project.city = ((address.find(item => item.types.includes("locality")) || {}).long_name || "")
    //         this.project.city = (this.user.city == "") ? ((address.find(item => item.types.includes("postal_town")) || {}).long_name || "") : ""
    //         this.project.zipCode = ((address.find(item => item.types.includes("postal_code")) || {}).long_name || "")
    //         this.project.stateProvince = ((address.find(item => item.types.includes("administrative_area_level_1")) || {}).long_name || "")
    //         this.project.country =((address.find(item => item.types.includes("country")) || {}).long_name || "")

    //         console.log(this.project)
    //       }
    //    } catch (error) {
    //       console.log(error.message);
    //    }
    // },
    setHeightImage() {
      var pic_box = $('.picture-box')
      if (pic_box && pic_box[0]) {
        var h = document.getElementById('content').clientHeight
        pic_box[0].style.height =
          (h > screen.availHeight ? h - 80 : screen.availHeight - 80) + 'px'
      }
    },

    changeType() {
      this.project.nameplateCapacity = '';
      if (this.project.type == "Solar Photovoltaic (PV)") {        
        this.isSolar = true;
        this.isCCType = false;
        this.isOtherType = false;
        this.isWind = false;
      }
      else if (this.project.type == "Carbon Credits") {
        this.isSolar = false;
        this.isCCType = true;
        this.isOtherType = false;
        this.isWind = false;
      }
      else if (this.project.type == "Wind") {
        this.isSolar = false;
        this.isCCType = false;
        this.isOtherType = false;
        this.isWind = true;
      }
      else {        
        this.isSolar = false;
        this.isOtherType = false;
        this.isCCType = false;
        this.isWind = false;
      }
    },

    showOther() {
      if (this.project.typeInverter == "other") {
        this.isOtherType = true;
      }
      else { 
        this.isOtherType = false;
      }
    },

    offGrid() {
      this.project.nameplateCapacity = "off";
      this.capacitySize = "off";
      this.isoffGrid = true;
    },
    clickNewPrj() {
      this.isNewPrj = (this.isNewPrj == true) ? false : true
      this.isDocs = (this.isNewPrj == true) ? false : true

    },
    autoFillUser () {
      var data = {}, keysUser = ["fullName", "email", "address", "address2", "city", "zipcode", "country", "phone", "company", "jobTitle", "walletAddressGREEN"];
      if (this.isUserAutofill==false) {
        this.user.fullName = this.arrUser.fullName
        this.user.email = this.arrUser.email
        this.user.address = this.arrUser.address
        this.user.address2 = this.arrUser.address2
        this.user.city = this.arrUser.city
        this.user.zipcode = this.arrUser.zipcode
        this.user.country = this.arrUser.country
        this.user.phone = this.arrUser.phone        
        this.user.company = this.arrUser.company
        this.user.jobTitle = this.arrUser.jobTitle
        this.user.walletAddressGREEN = this.arrUser.walletAddressGREEN
        this.isUserAutofill = true
      }
      else {
        for (var i=0; i<keysUser.length; i++)  {
          data[keysUser[i]] = this.user[keysUser[i]]           
        }
        this.arrUser = data;
        this.user.fullName = ""
        this.user.email = ""
        this.user.address = ""
        this.user.address2 = ""
        this.user.city = ""
        this.user.zipcode = ""
        this.user.country = ""
        this.user.phone = ""        
        this.user.company = ""
        this.user.jobTitle = ""
        this.user.walletAddressGREEN = ""
        this.isUserAutofill = false
      }  
    },
        // whenever the document is resized, re-set the 'fullHeight' variable
    handleResize(event) {
      this.setHeightImage()
    },

    getisdoc() {      
      if(this.isEdit){
        var doc = (typeof(this.project.documentations) == 'object') ? 'not empty' : this.project.documentations
        var own = (typeof(this.project.ownership) == 'object') ? 'not empty' : $(this.project.ownership).val()
        var cert = (typeof(this.project.CODCertificate) == 'object') ? 'not empty' : this.project.CODCertificate

        if (doc == '' && own == '' && cert == '') this.isdoc = true
        if (doc != '' && own == '' && cert == '') this.isdoc = true
        if (doc == '' && own != '' && cert == '') this.isdoc = true
      } else {         
        if ($(this.$refs.documentations).val() == '' && $(this.$refs.ownership).val() == '' && $(this.$refs.certificate).val()=='') this.isdoc = true
        if ($(this.$refs.documentations).val() != '' && $(this.$refs.ownership).val() == '' && $(this.$refs.certificate).val()=='') this.isdoc = true
        if ($(this.$refs.documentations).val() == '' && $(this.$refs.ownership).val() != '' && $(this.$refs.certificate).val()=='') this.isdoc = true     
      }   
    },

    saveDraftProject() {
      this.draft = true;
      this.saveProject();
    },

    async sendMessage(){
      try {
        console.log("ok")
        if(this.messageEdit == '') return false;
        Toast.success({
          toast: this.$toast,
          title: 'Success',
          message: 'Message has been successfully sent.',
        })
      } catch (error) {

        // console.log("error>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>")
        // console.log(error)

        Toast.error({
          toast: this.$toast,
          title: 'Error',
          message: 'Something went wrong.',
        })
      } finally {
        this.$refs.progress.hide()
      }
    },

    async saveProject() {
      try {
        this.isdoc = false
        
        if (!this.draft){
          const isValid = await this.$validator.validateAll('firstForm') 
          if (!this.isNewPrj){             
            this.getisdoc();
          }    
          if (!isValid || this.isdoc) {
            Toast.validationFieldsError({ toast: this.$toast })
            return
          }
        } else {
          if (this.project.name == "") {
            Toast.validationFieldsError({ toast: this.$toast })
            return
          }
        }              

        this.$refs.progress.show()

        this.project.latitude = (this.project.latitude == null || this.project.latitude == 'null') ? 0 : this.project.latitude;//this.$refs.googleMapProjectGeolocation.getPosition().latitude
        this.project.longitude = (this.project.longitude == null || this.project.longitude == 'null') ? 0 : this.project.longitude;//this.$refs.googleMapProjectGeolocation.getPosition().longitude

        this.user.latitude = 0; // this.$refs.googleMapProjectLocalPointGeolocation.getPosition().latitude
        this.user.longitude = 0; // this.$refs.googleMapProjectLocalPointGeolocation.getPosition().longitude 

        // this.project.type = this.$refs.selectType.value
        // this.project.country = this.$refs.selectCountry.value
        // this.user.country = this.$refs.selectUserCountry.value
        this.project.capacitySize = (this.capacitySize == 0) ? "MW" : "KW"

        // this.project.nameplateCapacity = (this.project.nameplateCapacity=="off")? '0' : this.project.nameplateCapacity;

        this.project.dateInstallation = this.month + "/" + this.day + "/" + this.year
         this.project.newPrj = this.isNewPrj

        var formData = new FormData(), userFormData = new FormData(), userArr = {}, keysUser = ["fullName", "email", "address", "city", "zipcode", "country", "phone", "company", "companyType", "jobTitle", "walletAddressGREEN"]
        for (var key in this.project) {
          formData.append(key, this.project[key])
        }

        for (var i=0; i<keysUser.length; i++)  {
          userArr[keysUser[i]] = (typeof this.user[keysUser[i]] == 'string') ? this.user[keysUser[i]].trim() : this.user[keysUser[i]]
          // userFormData.append(
          //     keysUser[i],
          //     userArr[keysUser[i]]
          // )
        }
        formData.append("owner",  JSON.stringify(userArr))
        
    
        if (this.project.documentations && typeof(this.project.documentations) == 'object')
          for (var i = 0; i < this.project.documentations.length; i++) {
            formData.append(
              'documentationfiles' + i,
              this.project.documentations[i]
            )
          }
        else 
            formData.append(
              'documentationfiles0',
              this.project.documentations
            )  

        if (this.project.ownership && typeof(this.project.ownership) == 'object')
          for (var i = 0; i < this.project.ownership.length; i++) {
            formData.append(
              'ownership' + i,
              this.project.ownership[i]
            )
          } 
        else 
            formData.append(
              'ownership0',
              this.project.documentations
            ) 

        if (this.project.presentation && typeof(this.project.presentation) == 'object')
          for (var i = 0; i < this.project.presentation.length; i++) {
            formData.append(
              'presentation' + i,
              this.project.presentation[i]
            )
          } 
        else 
            formData.append(
              'ownership0',
              this.project.documentations
            )         

        if (this.project.CODCertificate && typeof(this.project.CODCertificate) == 'object')
          for (var i = 0; i < this.project.CODCertificate.length; i++) {
            formData.append(
              'CODCertificate' + i,
              this.project.CODCertificate[i]
            )
          }  
        else 
            formData.append(
              'CODCertificate0',
              this.project.documentations
            )              

     
        if (this.project.images && this.project.images.length!=undefined){          
          for (
            var index = 0;
            !(!(index < this.project.images.length) || !(index < 5)); // Upload 5 images or less
            index++
          ) {
            formData.append('files' + index, this.project.images[index])
          }
        }
        else {
          this.project.images = null
          formData.append('images', null)
        }

        formData.append('draft', this.draft)
        
        this.project.typeInverter = (this.project.typeInverter && this.project.typeInverter == 'other') ? this.otherinverter : this.project.typeInverter;
        formData.append('typeInverter', this.project.typeInverter)

        var response
        if (this.isEdit) {
          formData.append('id', this.project.id)
          response = await Api.editProject(formData)
        } else {
          response = await Api.addProject(formData)
        }

        var responseUser = await Api.updateUserData(userFormData)
        
        this.$router.push(
          '/project/systemsdetail/existing/' + response.data.project._id
        )
      } catch (error) {
        console.log("error>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>")
        console.log(error)
        this.validationMessage = 'Something went wrong.'

        Toast.error({
          toast: this.$toast,
          title: 'Error',
          message: 'Something went wrong.',
        })
      } finally {
        this.$refs.progress.hide()
      }
    },

    onFileDocumentationsChange(event) {
      var files = event.target.files || event.dataTransfer.files
      this.project.documentations = files
    },

    onFileOwnershipChange(event) {
      var files = event.target.files || event.dataTransfer.files
      this.project.ownership = files
    },

    onFileCODChange(event) {
      var files = event.target.files || event.dataTransfer.files
      this.project.CODCertificate = files
    },

    onFilePPTChange(event) {
      var files = event.target.files || event.dataTransfer.files
      this.project.presentation = files
    },

    onFileChange(event) {
      var files = event.target.files || event.dataTransfer.files
      var fileList = Array.prototype.slice.call(event.target.files);

      this.project.images = files
      this.images = []

      if (this.project.images.length > 5) {
        this.$toast.error({
          title: 'Error',
          message: 'You can upload up to five images',
          color: '#BD362F',
        })
      }

      if (files && files[0]) {

        fileList.forEach(f => {        

            var reader = new FileReader()
            let _self = this

            reader.onload = e => {
              // var img = new Image()
              // img.onload = function() {
              //   _self.option.w = img.width / (img.height / 400)
              //   console.log('The width of the image is ' + img.width + 'px.')
              // }
              // img.src = reader.result
              // _self.option.img = e.target.result
              _self.images.push(e.target.result)
            }
            reader.readAsDataURL(f)
        })    
      }      
      /*
      var files = event.target.files || event.dataTransfer.files
      if (files && files[0]) {
        this.newAvatarImmage = files[0]

        // Auto refresh Avatar on page
        var self = this
        var reader = new FileReader()
        reader.onload = e => (self.userData.image = e.target.result)
        reader.readAsDataURL(files[0])
      }
      */

            /*        for (let i=0; i < files.length; i++)
        {
          this.images.push(files[i]);
        }
        for (let i=0; i<this.images.length; i++)
        {
              let reader = new FileReader(); //instantiate a new file reader
              reader.addEventListener('load', function(){
                this.$refs['image' + parseInt( i )][0].src = reader.result;
              }.bind(this), false);

          reader.readAsDataURL(this.images[i]);
         }*/
    },

    // backToGREEN() {
    //   this.$router.go(-1);
    // },

    cancelImage(index) {    
      var arrayImages = []
      arrayImages = this.images;
      
      var idx = arrayImages.indexOf(arrayImages[index]);
      arrayImages.splice(idx, 1);
      // console.log(arrayImages)
      // console.log(idx, index)
      var arr = {}, k=0;
      
      // if(this.project.images)
      // for (var i=0;i<this.project.images.length;i++){
      //   console.log("this.project.images[i]")
      //   console.log(this.project.images[i])

      //   if(i!=index) {
      //     console.log("if ****")
      //     console.log(this.project.images[i], i, index)

      //     arr[k]=this.project.images[i]
      //     k++
      //   }
      // }
      // this.project.images = null;
      // this.project.images = arr;
      if(this.project.images.length == 0) this.project.images = null
      // console.log("this.project.images *************************************")
      // console.log(this.project.images.length)
      console.log(this.project.images)
    },

    async getCurrentUser() {
      try {
        var response = await Api.myProfileSmallInfo()
        this.user = response.data.user
        this.affilietCode = response.data.affilietCode
        this.project.affilietCode = response.data.affilietCode

        this.user.country = this.user.country

        await new Promise(resolve => this.$nextTick(resolve))

        if (this.project.owner) {
          var owner = JSON.parse(this.project.owner)
          this.user.fullName = owner.fullName
          this.user.email = owner.email
          this.user.address = ""
          this.user.address2 = owner.address2
          this.user.city = owner.city
          this.user.zipcode = owner.zipcode
          this.user.country = owner.country
          this.user.phone = owner.phone
          this.user.company = owner.company
          this.user.companyType = owner.companyType
          this.user.jobTitle = owner.jobTitle
          this.user.walletAddressGREEN = owner.walletAddressGREEN          
        }

        // this.$refs.googleMapProjectLocalPointGeolocation.setPosition(
        //   this.user.location.latitude,
        //   this.user.location.longitude
        // )

      } catch (error) {
        this.validationMessage = 'Something went wrong.'

        Toast.error({
          toast: this.$toast,
          title: 'Error',
          message: 'Something went wrong.',
        })
      }
    },
    async getProject() {
      try {
        if (this.$route.name == "ProjectExistingEdit") {
          this.isEdit = true

          var response = await Api.getSystemsDetailById(this.$route.params.id)
          var resultDate = response.data.results[0]
          // console.log("data project************************** >>>>>>>>>>>>>>>>>>>>>>>>>>>>>**********************")
          // console.log(resultDate.project)

          this.project.id = resultDate.project._id
          this.project.name = resultDate.project.name
          this.project.greenTokenWallet = resultDate.project.greenTokenWallet
          this.project.streetAddress = resultDate.project.streetAddress
          this.project.streetAddress2 = resultDate.project.streetAddress2
          this.project.city = resultDate.project.city
          this.project.stateProvince = resultDate.project.stateProvince
          this.project.zipCode = resultDate.project.zipCode
          this.project.country = resultDate.project.country
          this.project.description= resultDate.project.description
          this.project.ppaPrice = resultDate.project.ppaPrice
          this.project.ppaDuration = resultDate.project.ppaDuration
          this.project.dateInstallation = resultDate.project.dateInstallation
          this.project.nameplateCapacity = (resultDate.project.nameplateCapacity == undefined) ? 0 : resultDate.project.nameplateCapacity
          if (resultDate.project.nameplateCapacity == "off") this.isoffGrid = true;

          this.project.affilietCode = resultDate.project.affilietCode
          this.project.type = resultDate.project.type
          this.project.typeInverter = resultDate.project.typeInverter
          this.project.owner = resultDate.project.owner
          this.project.confirmed = resultDate.project.confirmed
          this.project.ownerConfirmed = resultDate.project.ownerConfirmed
          this.project.newPrj = resultDate.project.newPrj
          this.isNewPrj = this.project.newPrj
          if (this.project.type == "Solar Photovoltaic (PV)") this.isSolar = true
          var arrV = Object.values(this.typesinverter)
          if (arrV.indexOf(this.project.typeInverter) == -1) {
              this.isOtherType = true
              this.otherinverter = this.project.typeInverter
          }              
          this.project.documentations = (resultDate.project.documentations && resultDate.project.documentations.length > 0 ) ? resultDate.project.documentations[0] : ''                    
          this.project.draft = resultDate.project.draft
          this.project.ownership = (resultDate.project.ownership && resultDate.project.ownership.length > 0 ) ? resultDate.project.ownership[0] : ''
          this.project.CODCertificate = (resultDate.project.CODCertificate && resultDate.project.CODCertificate.length > 0 ) ? resultDate.project.CODCertificate[0] : ''
          this.project.presentation = (resultDate.project.presentation && resultDate.project.presentation.length > 0 ) ? resultDate.project.presentation[0] : ''
          this.project.latitude = resultDate.project.latitude
          this.project.longitude = resultDate.project.longitude
          this.project.country = this.project.country
          this.project.type = this.project.type          
          this.project.public = (resultDate.project.public == undefined) ? true : resultDate.project.public
          this.project.social = (resultDate.project.social == undefined) ? false : resultDate.project.social      
          this.project.socialManner = (resultDate.project.socialManner == undefined) ? '' : resultDate.project.socialManner      
          this.project.funding = (resultDate.project.funding == undefined) ? false : resultDate.project.funding
          this.project.fundingAmount = (resultDate.project.fundingAmount == undefined) ? 0 : resultDate.project.fundingAmount
          this.project.fundingAmountCurrency = (resultDate.project.fundingAmountCurrency == undefined) ? '' : resultDate.project.fundingAmountCurrency
          this.option.img = resultDate.project.images[0]
          this.images = resultDate.project.images
          this.project.images = resultDate.project.images
          let date = (this.project.dateInstallation) ? this.project.dateInstallation.split('/') : null
          if (this.project.dateInstallation){
            this.month = date[0]            
            this.day = date[1]
            this.year = date[2]
          }
          this.capacitySize = (resultDate.project.capacitySize == "MW") ? 0 : 1

          await new Promise(resolve => this.$nextTick(resolve))

          // this.$refs.googleMapProjectGeolocation.setPosition(
          //   this.project.latitude,
          //   this.project.longitude
          // )
        }
      } catch (error) {
        this.validationMessage = 'Something went wrong.'

        Toast.error({
          toast: this.$toast,
          title: 'Error',
          message: 'Something went wrong.',
        })
      }
    },
    updateSearch() {
    //   var address
    //   console.log(document.getElementById('google-map-user-info_map_edit'))
    //   if(this.project.streetAddress != "" && this.project.streetAddress != undefined) {
    //     console.log("address 1 ************************************")
    //     console.log(this.address)
    //     this.address = this.address + this.project.streetAddress
    //     this.sign = ","
    //   }
    //   if(this.project.city != "" && this.project.city != undefined) {
    //     console.log("address 2 ************************************")
    //     console.log(this.address)
    //     this.address = this.address + this.sign + this.project.city
    //     this.sign2 = ","
    //   }
    //   console.log("address************************************")
    //   console.log(this.address)
    //   document.getElementById('google-map-user-info_map_edit').value = this.address
    },
    updateSearchCountry() {
    //   if(this.project.country != "" && this.project.country != undefined) {
    //     console.log("address 3 ************************************")
    //     console.log(this.address)
    //     this.address = this.address + this.sign + this.project.country
    //     document.getElementById('google-map-user-info_map_edit').focus()
    //   }
    //   document.getElementById('google-map-user-info_map_edit').value = this.address
    },
    openPreview() {
      this.editMode = false

      // this.$refs.googleMapPreviewProjectGeolocation.setPosition(
      //   this.$refs.googleMapProjectGeolocation.getPosition().latitude,
      //   this.$refs.googleMapProjectGeolocation.getPosition().longitude
      // )
    }
  },
  async created() {
    this.countries = require('./../../../../data/country.js')

    await this.getProject()
    await this.getCurrentUser()

    // $('[data-toggle="tooltip"]').tooltip();
    $('.form-line').tooltip({
        selector: "[data-toggle=tooltip]",
        container: "body"
    })

    await new Promise(resolve => this.$nextTick(resolve))

    this.$refs.progress.hide()
  },
  mounted() {
    this.setHeightImage()
    this.user.country = "United Kingdom"
    window.addEventListener('resize', this.handleResize)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
  },
}



// WEBPACK FOOTER //
// ./src/components/Project/SystemsDetail/ProjectExistingAdd/ProjectExistingAdd.component.js